import { Box, Center, Grid, Text } from '@chakra-ui/layout'
import { Button } from '@chakra-ui/button'
import { Image } from '@chakra-ui/react'

import Error404Image from '@/images/errors/404-error.png'
import { errorPageButtonStyle } from './styles'

function Error404() {
  return (
    <Center
      sx={{
        w: '100%',
        h: '100vh',
        bg: 'white',
      }}
    >
      <Box maxW="850px" m="0 auto" p="4">
        <Grid gridTemplateColumns="max-content 1fr" gap="4" alignItems="center">
          <Box mr="32px" textAlign="center">
            <Image maxW="430px" src={Error404Image} />
          </Box>

          <Grid gap="1">
            <Text as="h2" fontSize="36px" fontWeight="700">
              Oops!
            </Text>
            <Text fontSize="26px">This page you looking for</Text>
            <Text fontSize="26px">is not found.</Text>

            <Button sx={errorPageButtonStyle} as="a" href="/">
              Back Homepage
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Center>
  )
}

export default Error404
